import type {Translate} from 'localization/context/types';
import type {EditorMode} from '../../types';

export const getSavedAgentMessage = (mode: EditorMode, t: Translate) =>
  t(`page.agents.${mode}.save.success`);
